import { TranscriptLine, TranscriptSpeaker } from "./click-to-call.model";

/** "02:14" — minutes may pass 59 ("75:03"); negative input reads as zero. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(total / 60).toString().padStart(2, "0");
  return `${minutes}:${(total % 60).toString().padStart(2, "0")}`;
}

/**
 * Adds a result, or replaces the earlier (partial) text of the same result id. The entry keeps
 * the time it first appeared, so it does not jump as the partial text firms up.
 */
export function upsertTranscriptLine(lines: TranscriptLine[], line: TranscriptLine): TranscriptLine[] {
  const index = lines.findIndex((l) => l.id === line.id);
  if (index < 0) return [...lines, line];
  const next = lines.slice();
  next[index] = { ...line, atMs: lines[index].atMs };
  return next;
}

/** Partial text still on screen when the call ends is kept as said. */
export function settleTranscript(lines: TranscriptLine[]): TranscriptLine[] {
  return lines.some((l) => l.partial) ? lines.map((l) => (l.partial ? { ...l, partial: false } : l)) : lines;
}

export function speakerLabel(speaker: TranscriptSpeaker, customerLabel: string): string {
  if (speaker === "agent") return "You";
  if (speaker === "customer") return customerLabel;
  return "Speaker";
}

export interface TranscriptExportHeader {
  title: string;
  contact: string;
  number: string;
  startedAt: Date;
  duration: string;
  status: string;
}

/** Plain-text transcript for Copy and Download: a short header, then "[mm:ss] Speaker: text" lines. */
export function transcriptText(header: TranscriptExportHeader, lines: TranscriptLine[], customerLabel: string): string {
  const started = header.startedAt.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  const head = [
    header.title,
    header.contact ? `Contact: ${header.contact}` : "",
    `Number: ${header.number}`,
    `Started: ${started}`,
    `Duration: ${header.duration}`,
    `Status: ${header.status}`,
  ].filter(Boolean);
  const body = lines.map((l) => `[${formatClock(l.atMs)}] ${speakerLabel(l.speaker, customerLabel)}: ${l.text}`);
  return [...head, "", ...body].join("\n") + "\n";
}

/** "phone-call-transcript-2026-10-13-1946.txt" — no number or name in the file name. */
export function transcriptFileName(startedAt: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const d = startedAt;
  return `phone-call-transcript-${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}.txt`;
}
